"use client";

import type { PropsWithChildren } from "react";
import { motion } from "framer-motion";
import { usePathname } from "next/navigation";
import { isLegalPagePath } from "@/lib/legal-pages";

interface CSSStaggerContainerProps extends PropsWithChildren {
  className?: string;
  staggerDelay?: number;
  viewport?: boolean;
  allowReanimation?: boolean;
}

export function CSSStaggerContainer({
  children,
  className,
  staggerDelay = 0.1,
  viewport = true,
  allowReanimation = false,
}: CSSStaggerContainerProps) {
  const pathname = usePathname();
  if (isLegalPagePath(pathname)) {
    return <div className={className}>{children}</div>;
  }

  const variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: staggerDelay,
        delayChildren: 0.1,
      },
    },
  };

  if (viewport) {
    return (
      <motion.div
        variants={variants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: !allowReanimation, amount: 0.1 }}
        className={className}
      >
        {children}
      </motion.div>
    );
  }

  return (
    <motion.div variants={variants} initial="hidden" animate="visible" className={className}>
      {children}
    </motion.div>
  );
}
